import { render, staticRenderFns } from "./ValidateInvite.vue?vue&type=template&id=1af40e2e"
import script from "./ValidateInvite.vue?vue&type=script&lang=js"
export * from "./ValidateInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports